import { createEffect, createEvent, sample } from "effector";
import { audio, audioVolumeSet } from "frontend/src/domain/audio";
export var audioVolumeChanged = createEvent();
var audioVolumeChangedFx = createEffect(function (volume) { return (audio.volume = volume); });
sample({
    clock: audioVolumeChanged,
    target: [audioVolumeChangedFx, audioVolumeSet],
});
